import Vue from 'vue'

import Qs from 'qs'

class Articles {
  async index({params}) {
    return await Vue.axios
      .get('app/articles', {
        params,
        paramsSerializer: (params) => {
          return Qs.stringify(params)
        }
      })
  }

  async create({data}) {
    return await Vue.axios
      .post('app/articles', data)
  }

  async read({id}) {
    return await Vue.axios
      .get('app/articles/' + id)
  }

  async update({id, data}) {
    return await Vue.axios
      .put('app/articles/' + id, data)
  }

  async delete({id}) {
    return await Vue.axios
      .delete('app/articles/' + id)
  }
}

const articles = new Articles()

export default articles
